import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {ClickEventHandler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {TransparentButton} from '../../../libs/shared/ui/src/components/buttons/transparentButton';

interface InfoBannerProps {
  // Content.
  emoji: React.ReactNode;
  buttons?: ReadonlyArray<InfoBannerButtonProps>;
}

interface InfoBannerButtonProps {
  label: string;
  onClick?: ClickEventHandler;
}

const StyledBannerWrapperDiv = styled.div`
  display: grid;

  grid-template-areas: 'icon content buttons';
  grid-template-columns: 16px 1fr auto;
  grid-column-gap: 10px;

  border-radius: 100px;
  padding: 5px;
  padding-left: 17px;

  background: #edf5fe;
`;

const StyledBannerIconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledBannerContentDiv = styled.div`
  display: flex;
  align-items: center;

  line-height: 16px;
  font-size: 12px;
  color: ${(p) => p.theme.greys.shade80};
  font-weight: 500;
`;

export const InfoBanner: FC<PropsWithChildren<InfoBannerProps>> = (props) => {
  const {buttons, children, emoji} = props;

  return (
    <StyledBannerWrapperDiv>
      <StyledBannerIconDiv>{emoji}</StyledBannerIconDiv>
      <StyledBannerContentDiv>{children}</StyledBannerContentDiv>
      {buttons && (
        <div>
          {buttons.map(({label, onClick}) => (
            <TransparentButton onClick={onClick} key={label}>
              {label}
            </TransparentButton>
          ))}
        </div>
      )}
    </StyledBannerWrapperDiv>
  );
};
